<template>
  <div name="addendums" class="ml-5 mr-5 mb-12">
    <v-row dense>
      <v-col
        class="col-md-2"
        style="text-align: center"
        v-for="(file, index) in addendums"
        :key="file.fileName"
        :id="index"
      >
        <!--<img id="imgSign" :src="'data:image/*;base64,'+file.bytes"/>-->
        <!--<pdf :src="'data:pdf/*;base64,'+file.bytes"></pdf>-->
        <v-icon
          @click="openPDF(file)"
          type="button"
          size="100px"
          :color="
            file.type === 'pdf'
              ? 'error'
              : file.type === 'jpeg' ||
                file.type === 'jpg' ||
                file.type === 'png'
              ? 'secondary'
              : file.type === 'zip' || file.type === 'rar'
              ? 'green'
              : 'grey'
          "
          >{{
            file.type === "pdf"
              ? "mdi-file-pdf-box"
              : file.type === "jpeg" ||
                file.type === "png" ||
                file.type === "jpg"
              ? "mdi-image"
              : file.type === "zip" || file.type === "rar"
              ? "mdi-zip-box"
              : "mdi-file"
          }}</v-icon
        >
        <h1 style="font-size: 2.4vh; text-align: center">
          {{ file.name }}
        </h1>
      </v-col>
    </v-row>
    <v-row v-if="this.$utilFront.isNull(addendums) || addendums.length == 0">
      <v-col>
        <strong><h3>No se encontraron archivos</h3></strong>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogViewer"
      persistent
      max-width="800px"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title class="text-h6 text-center"> Archivo anexo </v-card-title>
        <v-card-text> Nombre: {{ file.fileName }} </v-card-text>

        <div
          class="container"
          v-if="file.type != 'application/pdf' && file.type != 'pdf'"
        >
          <div style="justify-content: center" class="row overflow-y-auto">
            <img
              id="imgSign"
              download
              width="auto"
              height="400"
              :src="'data:image/*;base64,' + file.bytes"
            />
          </div>
        </div>
        <div
          class="container"
          v-if="file.type != 'application/pdf' && file.type == 'pdf'"
        >
          <div style="justify-content: center" class="row overflow-y-auto">
            <iframe
              :src="'data:application/pdf;base64,' + file.bytes"
              width="100%"
              height="600"
            ></iframe>
          </div>
        </div>
        <v-card-actions style="justify-content: center">
          <v-btn color="secondary" text @click="dialogViewer = false">
            <v-icon left>mdi-chevron-left</v-icon>Regresar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="download(file)"
            v-if="file.type != 'application/pdf' && file.type != 'pdf'"
          >
            Descargar<v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    addendums: Array,
  },
  data() {
    return {
      dialogViewer: false,
      file: {},
    };
  },
  methods: {
    async openPDF(file) {
      this.file = file;
      this.dialogViewer = true;
      //  if (file.type == "pdf") {
      //   // let byteChar = atob(file.bytes)
      //   // let byteNumbers = new Array(byteChar.length);
      //   // for (let i = 0; i < byteNumbers.length; i++){
      //   //   byteNumbers[i] = byteChar.charCodeAt(i);
      //   //   let byteArray = new Uint8Array(byteNumbers);
      //   //   this.$utilFront.openPDF(byteArray);
      //   // }
      //   let w = window.open("about:blank");
      //    setTimeout(function() {
      //      w?.document.write(`
      //        <!DOCTYPE html>
      //          <head>
      //          <title>Informe</title>
      //          </head>
      //          <body>
      //          <iframe src="data:application/pdf/pdf;base64,${file.bytes}" width="100%">
      //          </body>
      //        </html>`);
      //    }, 0);
      //  } else if (file.type == "jpg") {
      //    let w = window.open("about:blank");
      //    setTimeout(function() {
      //      w?.document.write(`
      //        <!DOCTYPE html>
      //          <head>
      //          <title>Informe</title>
      //          </head>
      //          <body>
      //          <img src="data:image/jpg;base64,${file.bytes}" width="70%">
      //          </body>
      //        </html>`);
      //    }, 0);
      //  } else if (file.type == "png") {
      //    let w = window.open("about:blank");
      //    setTimeout(function() {
      //      w?.document.write(`
      //        <!DOCTYPE html>
      //          <head>
      //          <title>Informe</title>
      //          </head>
      //          <body>
      //          <img src="data:image/png;base64,${file.bytes}" width="70%">
      //          </body>
      //        </html>`);
      //    }, 0);
      //  }
    },
    download(file) {
      let a = document.createElement("a"); //Create <a>
      a.href = "data:image/png;base64," + file.bytes; //Image Base64 Goes here
      a.download = file.fileName; //File name Here
      a.click(); //Downloaded file
      // const url = URL.createObjectURL(
      //       new Blob([file.bytes], {
      //         type: file.type,
      //       })
      //     );
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", file.fileName);
      //     document.body.appendChild(link);
      //     link.click();

      //     document.body.removeChild(link);
    },
  },
};
</script>

<style></style>
